<template>
    <v-container>
        <v-row justify='center'>
            <v-col lg=5>
                 <v-card>
                    <v-card-text>
                        <v-card-title> Save your Address</v-card-title>
                            <v-form class='pa-4' ref="form">
                                <v-text-field v-model="address1" :rules="[rules.required]" label='Address Line 1' solo dense></v-text-field>
                                <v-text-field v-model="address2" label='Address Line 2' solo dense></v-text-field>
                                <v-text-field v-model="city" :rules="[rules.required]" label='City' solo dense></v-text-field>
                                <v-text-field v-model="state" :rules="[rules.required]" label='State' solo dense></v-text-field>
                                <v-text-field v-model="pincode" :rules="[rules.required]" label='PIN Code' solo dense></v-text-field>
                                <v-btn class='mb-5' block color="primary" @click="saveDetails">
                                    Save Details
                                </v-btn>
                            </v-form>
                    </v-card-text>
             </v-card>
            </v-col>
             
        </v-row>
      
    </v-container>
    
</template>
<script>
/*global myBaseURL*/
import axios from 'axios';

export default {
    name:'AddDetails',
    data(){
        return {
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
            address1 : '',
            address2 : '',
            city : '',
            state : '',
            pincode : '',
            store_slug : this.$route.params.store_slug,
            unique_id : ''
        }
    },
    created(){
        if(window.localStorage.getItem('unique_id') && window.localStorage.getItem('unique_id') != '')
        {
            this.unique_id = window.localStorage.getItem('unique_id');
        }
    },
    methods : ({
        saveDetails()
        {
            var that = this;
            if(this.$refs.form.validate())
            {
                axios.request({
                    url: '/customer/details/' + that.store_slug,
                    method: 'POST',
                    baseURL: myBaseURL,
                    headers: {
                        'Authorization': 'Bearer '+ window.localStorage.access_token
                    },
                    data : {
                        'address1' : that.address1,
                        'address2' : that.address2,
                        'city' : that.city,
                        'state' : that.state,
                        'pincode' : that.pincode,
                        'unique_id' : that.unique_id
                    }
                }).then(response => {
                    console.log(response.data);
                    console.log('Success Data');
                    // that.customer_id = response.data.id;
                    that.$router.push({ path: '/' + this.$route.params.store_slug });
                }).catch(e => {
                    console.log(e);
                    console.log('Fail Data');
                });
            }
        },
    })
}
</script>